<template>
  <div class='l-app-wrap on-touch'>
    <div class="v-overlay__small">
      <ScreenTooSmall />
    </div>
    <!-- <transition name='slide-fade'> -->
      <router-view></router-view>
    <!-- </transition> -->
    <transition name='fade'>
      <Promotion v-if='getShowPromotionStatus'/>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Promotion from './components/Promotion';
import ScreenTooSmall from './views/ScreenTooSmall';

export default {
  name: 'App',
  data() {
    return {
      newUser: {
        name: '',
        email: '',
      },
    };
  },
  created() {
    this.authenticateFirebase();
  },
  components: {
    Promotion,
    ScreenTooSmall,
  },
  computed: {
    ...mapGetters(['getShowPromotionStatus', 'getGameOverStatus']),
    showPromotion() {
      return this.getShowPromotionStatus;
    },
    showGameOver() {
      return this.getGameOverStatus;
    },
  },
  methods: {
    ...mapActions(['setShowPromotionStatus', 'authenticateFirebase']),
    togglePromotion() {
      let showPromotion = this.getShowPromotionStatus;
      showPromotion = !showPromotion;
      this.toggleShowPromotionStatus(showPromotion);
    },
  },
};
// eslint-disable-next-line
window.addEventListener('touchstart', function onFirstTouch() {
  document.body.classList.add('user-is-touching');
}, false);
</script>

<style>
body {
  background: black;
}
.l-app-wrap {
  position: relative;
  width: 960px;
  height: 630px;
  margin: auto;
  overflow: hidden;
  background:lightgrey;
}
.container {
  padding: 10px;
}

.v-overlay__small {
  display: none;
  height: 100%;
  width: 100%;
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  background: black;
  color: white;
  padding-top: 30px;
}

@media screen and (max-width: 959px) {
  .l-app-wrap {
    width: 100%;
  }
  .v-overlay__small {
    display: block;
  }
}
</style>

<style src='./assets/scss/styles.scss' lang='scss' />



// WEBPACK FOOTER //
// src/App.vue